import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";
import Link from "components/link";
import Dialog from "components/dialog";

const WarningActiveEvent = ({ children, source, intl, history }) => {
  const [showWarning, setShowWarning] = useState(
    Boolean(source && source.deploymentId &&  source.firstActiveEventRelated && source.firstActiveEventRelated.id),
  );

  const handleHideWarning = useCallback(() => setShowWarning(false), []);

  const handleReturn = useCallback(() => history.goBack(), [history]);

  return showWarning ? (
    <Dialog
      onClose={handleReturn}
      onAccept={handleHideWarning}
      open={showWarning}
      disableBackdropClick
      disableEscapeKeyDown
      title={intl.formatMessage({ id: "common.warning" })}
    >
      <FormattedMessage
        id="app.source.details.hasActiveEvents.warning"
        values={{
          eventLink: Boolean(source.firstActiveEventRelated && source.firstActiveEventRelated.id) ? (
            <Link color="primary" href={`/event/details/${source.firstActiveEventRelated.id}`}>
              {source.firstActiveEventRelated.title}
            </Link>
          ) : null,
        }}
      />
    </Dialog>
  ) : (
    children
  );
};

WarningActiveEvent.propTypes = {
  /**
   * Data to represent
   **/
  source: PropTypes.object,
};

export default withRouter(injectIntl(WarningActiveEvent));
